define("analytics-resources/components/analytics-resource/bar", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "analytics-resources/utils/charts/chart-utils", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _chartUtils, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"analytics-resources/utils/charts/chart-utils",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cCH--chartContainer" {{did-insert this.chart}} {{did-update this.chart @chartData @chartState}}>
    <div class="cCH--chartInfo">
      <div class="cCH--header">
        <h4 class="tAN--header--secondary">
          {{@text.title}}
  
          <EmberTooltip @event="hover">
            <span>
              {{@text.tooltip}}
            </span>
          </EmberTooltip>
  
        </h4>
      </div>
    </div>
  
    <div class="cCH--chart">
      <div id={{this.chartId}}></div>
  
      {{#if this.showEmptyChart}}
        <div class="cCH--chart__overlay"></div>
      {{/if}}
  
      {{#if (eq @chartState "loading")}}
        <div class="cCH--chart__overlay">
          <p class="u--m__b__0">
            {{t "analytics-resources.state.loading"}}
          </p>
        </div>
      {{else if (eq @chartState "no-data")}}
        <div class="cCH--chart__overlay">
          <p class="u--m__b__0">
            {{t "analytics-resources.state.no_data"}}
          </p>
        </div>
      {{else if (eq @chartState "error")}}
        <div class="cCH--chart__overlay">
          {{#if (has-block "errorOverlay")}}
            {{yield to="errorOverlay"}}
          {{else}}
            <p class="u--m__b__0">
              {{t "analytics-resources.state.error"}}
            </p>
          {{/if}}
        </div>
      {{else}}
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "SwG6926o",
    "block": "[[[11,0],[24,0,\"cCH--chartContainer\"],[4,[38,0],[[30,0,[\"chart\"]]],null],[4,[38,1],[[30,0,[\"chart\"]],[30,1],[30,2]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCH--chartInfo\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cCH--header\"],[12],[1,\"\\n      \"],[10,\"h4\"],[14,0,\"tAN--header--secondary\"],[12],[1,\"\\n        \"],[1,[30,3,[\"title\"]]],[1,\"\\n\\n        \"],[8,[39,2],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[30,3,[\"tooltip\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"cCH--chart\"],[12],[1,\"\\n    \"],[10,0],[15,1,[30,0,[\"chartId\"]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showEmptyChart\"]],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,4],[[30,2],\"loading\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"analytics-resources.state.loading\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,2],\"no-data\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"analytics-resources.state.no_data\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,2],\"error\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"          \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"analytics-resources.state.error\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@chartData\",\"@chartState\",\"@text\",\"&errorOverlay\"],false,[\"did-insert\",\"did-update\",\"ember-tooltip\",\"if\",\"eq\",\"t\",\"has-block\",\"yield\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/bar.hbs",
    "isStrictMode": false
  });
  let BarComponent = _exports.default = (_dec = (0, _service.inject)('highcharts-library'), (_class = class BarComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "highchartsLibrary", _descriptor, this);
      _defineProperty(this, "chartId", `growth-chart-bar-${(0, _uuid.default)()}`);
    }
    get showEmptyChart() {
      return (0, _chartUtils.showEmptyChart)(this.args.chartState);
    }
    get chartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          type: 'bar',
          className: this.args.customChartClass || 'detailed-y-chart'
        },
        xAxis: {
          categories: this.args.chartData?.map(bar => bar.name),
          title: {
            text: null
          }
        },
        series: [{
          type: 'bar',
          data: this.args.chartData ?? [],
          name: this.args.text.series,
          className: 'cCH--chartColor'
        }]
      };
    }
    get emptyChartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          type: 'bar',
          className: 'cCH--chart--disabled'
        },
        tooltip: {
          enabled: false
        },
        xAxis: {
          categories: ['loading', 'loading', 'loading'],
          title: {
            text: null
          }
        },
        series: [{
          type: 'bar',
          data: [{
            name: 'loading...',
            y: 2,
            colorIndex: 1,
            pointPadding: 0
          }, {
            name: 'loading...',
            y: 1,
            colorIndex: 1,
            pointPadding: 0
          }, {
            name: 'loading...',
            y: 3,
            colorIndex: 1,
            pointPadding: 0
          }],
          name: this.args.text.series,
          className: 'cCH--chart--disable'
        }]
      };
    }
    get commonOptions() {
      return {
        title: undefined,
        chart: {
          styledMode: true,
          height: this.args.chartOptions.height || undefined,
          spacing: [25, 0, 0, 0]
        },
        yAxis: {
          visible: false,
          title: {
            text: null
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            states: {
              hover: {
                enabled: false
              }
            }
          }
        }
      };
    }
    chart() {
      const chartOptions = this.showEmptyChart ? this.emptyChartOptions : this.chartOptions;
      this.highchartsLibrary.chart(this.chartId, chartOptions);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "highchartsLibrary", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "chart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chart"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BarComponent);
});